module.exports = __webpack_public_path__ + "img/asset11x1.2c3c4b03.png";